// v1 apps/frontend/client/src/components/MillsheetPrintForm/style.ts の移植（そのまま）
export const pageSize = {
  width: '210mm',
  height: '295.5mm',
}

export const pageStyle = /* css */ `
@page {
  size: A4 portrait;
  margin: 0; // ヘッダー・フッターが出力されないように
}

* {
  margin: 0;
  padding: 0;
  user-select: none;
}

body {
  width: 210mm;

  svg {
    width: 210mm;
    height: 295.5mm; // 297mmだと2ページ目にはみ出してしまうので微調整
    page-break-after: always;
  }
}

// プレビュー用
@media screen {
  body {
    background: #ccc;
    margin: 0 auto;

    svg {
      background: #fff;
      box-shadow: 0 .5mm 2mm rgba(0, 0, 0, .3);
      margin-top: 5mm;
    }
  }
}

.pdf-container {
  width: 100%;
  overflow: hidden;
}
#pdf-iframe {
  width: 380px;
  border: none;
}

@media print {
  .pdf-container {
    width: 100%;
    height: 100%;
  }
  #pdf-iframe {
    width: 120%;
    height: 100%;
  }
}
`
